<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.5 1a1 1 0 00-1 1v.509c-.865.02-1.412.089-1.862.318a3 3 0 00-1.311 1.311C1 4.78 1 5.62 1 7.3v2.862c0 1.68 0 2.52.327 3.162a3 3 0 001.311 1.31c.642.328 1.482.328 3.162.328h4.4c1.68 0 2.52 0 3.162-.327a3 3 0 001.311-1.311c.327-.642.327-1.482.327-3.162V7.3c0-1.68 0-2.52-.327-3.162a3 3 0 00-1.311-1.311c-.45-.23-.997-.298-1.862-.318V2a1 1 0 10-2 0v.5h-3V2a1 1 0 00-1-1zM3.25 7a.75.75 0 00-.75.75V12A1.5 1.5 0 004 13.5h8a1.5 1.5 0 001.5-1.5V7.75a.75.75 0 00-.75-.75h-9.5z"
    fill="currentColor"
  />
</svg>
